import base from "../baseurl";
import token from "../getTk";

const Delete = async (Uuid) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const remove = await api
    .post("candidate-worksheets/delete", {
      json: {
        candidateWorkSheetUuid: Uuid,
      },
    })
    .json();
  //console.log(Create);
  return remove;
};

export default Delete;
